import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';
import fonts from '../../../../utils/Fonts';

const WeekViewElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Week Viewer',
  icon: 'DocumentIcon',
  description:
    'Adds a Week view, to view documents that slot into days of the week',
  properties: [
    {
      label: 'Week Header Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run the week header is tapped.',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Add Day Item Action',
      name: 'actionDay',
      editor: 'dropdown',
      default: '',
      description:
        'An action to when the plus icon is tapped on a day slot. When an empty slot is pressed, the local store is updated with a key called weekViewSelectedSlot with a structure of {"name":"Tuesday","documents":[],"date":"8th Nov 2022","dateIso":"2022-11-08T00:13:24.743Z","dateFirestore":{"seconds":1667866404,"nanoseconds":743000000},"week":46,"day":2,"year":2022,"month":10,"monthName":"November"}',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Edit Day Item Action',
      name: 'actionEdit',
      editor: 'dropdown',
      default: '',
      description:
        'An action to when a filled day slot is tapped. When a slot is pressed, the local store is updated with a key called weekViewSelectedSlot with a structure of {"name":"Tuesday","document": { the document in the slot },"documents":[],"date":"8th Nov 2022","dateIso":"2022-11-08T00:13:24.743Z","dateFirestore":{"seconds":1667866404,"nanoseconds":743000000},"week":46,"day":2,"year":2022,"month":10,"monthName":"November"}',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Active Week Calendar Button Background Color',
      name: 'activeCalendarButtonBackgroundColor',
      editor: 'color',
      default: '',
      description:
        'The background color of the calendar button for the active week',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Active Week Calendar Button Text Color',
      name: 'activeCalendarButtonColor',
      editor: 'color',
      default: '',
      description: 'The text color of the calendar button for the active week',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Calendar Button Background Color',
      name: 'calendarButtonBackgroundColor',
      editor: 'color',
      default: '',
      description:
        'The background color of the calendar button for the previous weeks',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Calendar Button Text Color',
      name: 'calendarButtonColor',
      editor: 'color',
      default: '',
      description:
        'The text color of the calendar button for the previous weeks',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Empty Slot Background Color',
      name: 'emptySlotBackgroundColor',
      editor: 'color',
      default: '',
      description: 'The background color of an empty day slot',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Empty Slot Text Color',
      name: 'emptySlotColor',
      editor: 'color',
      default: '',
      description: 'The text color of an empty day slot',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Filled Slot Background Color',
      name: 'filledSlotBackgroundColor',
      editor: 'color',
      default: '',
      description: 'The background color of a filled day slot',
      options: [],
      function: {
        name: '',
        params: []
      },

      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Filled Slot Text Color',
      name: 'filledSlotColor',
      editor: 'color',
      default: '',
      description: 'The text color of an filled slot',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Slot Title Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the title when the slot is not empty',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Slot Date Field',
      name: 'dateField',
      editor: 'dropdown',
      description:
        'The date field within documents of the underlining data source.',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Slot Title Markup',
      name: 'datasourceFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Slot Sub-Title Field',
      name: 'subTitleField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the sub-title when the slot is not empty',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Slot Sub-Title Markup',
      name: 'datasourceSubTitleFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title Font',
      name: 'titleFont',
      editor: 'fontsize',
      description: 'The font for the title in a filled slot',
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Title Font Family',
      name: 'titleFontFamily',
      editor: 'dropdown',
      type: 'number',
      default: 14,
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'The font family of the title in a filled slot',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Sub-Title Font',
      name: 'subTitleFont',
      editor: 'fontsize',
      description: 'The font for the sub-title in a filled slot',
      type: 'number',
      default: 14,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Sub-Title Font Family',
      name: 'subTitleFontFamily',
      editor: 'dropdown',
      type: 'string',
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'The font family for the sub-title filled slot',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Date Font',
      name: 'dateFont',
      editor: 'fontsize',
      description: 'The font for dates in slots',
      type: 'number',
      default: 14,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Date Font Family',
      name: 'dateFontFamily',
      editor: 'dropdown',
      type: 'string',
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'The font family dates in slots',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Day Name Font',
      name: 'dayNameFont',
      editor: 'fontsize',
      description: 'The font for day names in slots',
      type: 'number',
      default: 18,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Day Name Font Family',
      name: 'dayNameFontFamily',
      editor: 'dropdown',
      type: 'string',
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'The font family for day names in slots',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    }
  ]
};

export default WeekViewElementFields;
